/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".m-t-20[_ngcontent-%COMP%]{margin-top:20px}.m-t-40[_ngcontent-%COMP%]{margin-top:40px}.m-t-80[_ngcontent-%COMP%]{margin-top:80px}.btn-primary[_ngcontent-%COMP%]{color:#fff;background-color:#3a9af9;border-color:#3a9af9}\n/*# sourceMappingURL=account.component.css.map*/"];
export { styles as styles };
